<div *transloco="let t; read: 'configuration-routes.edit'" class="xi-modal__container">
  <h2 class="xi-modal__title text-center">{{ t('title') }}</h2>

  <div class="xi-modal__content">
    <p>{{ t('content') }}</p>

    <app-included-configurations-form
      [configurationRoute]="configurationRoute"
      [isSaving]="isSaving"
      (includedConfigurationsChange)="onIncludedConfigurationsChanged($event)"
    ></app-included-configurations-form>
  </div>

  <div class="xi-modal__actions">
    <xi-default-button
      type="button"
      [text]="t('cancel')"
      fill="text"
      (onClick)="cancel()"
    ></xi-default-button>

    <xi-default-button
      [text]="t('save')"
      (onClick)="save()"
      [disabled]="!isSaveEnabled"
    ></xi-default-button>
  </div>
</div>
